import getAgentSuggestionsListData from "../../../store/aiAgent/agentSuggestions/AgentSuggestions";
import { AI_AGENT_LANGUAGES } from "../../../utils/helpers/aiAgent/languages";
import classes from "./AgentLanguageSelector.module.css";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const AgentLanguageSelector = (props) => {
  const { lang, langOpen, setLang, setLangOpen, cachedSuggestions, setCachedSuggestions, suggestionsList, setIsLoading, t } = props;
  const dispatch = useDispatch();

  const selectedLang = AI_AGENT_LANGUAGES.find((l) => l.code === lang);

  useEffect(() => {
    if (cachedSuggestions[lang]) return;
    setIsLoading(true);
    dispatch(getAgentSuggestionsListData(lang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, lang]);

  useEffect(() => {
    if (suggestionsList?.[lang]?.length && !cachedSuggestions[lang]) {
      setCachedSuggestions((prev) => ({ ...prev, [lang]: suggestionsList[lang] }));
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestionsList, lang]);

  return (
    <div className={classes.langRow}>
      <span className={classes.langLabel}>{t("speech_language")}</span>

      <div className={classes.langSelect}>
        <button className={classes.langTrigger} onClick={() => setLangOpen((v) => !v)}>
          <span>{selectedLang.flag}</span>
          <span>{t(selectedLang.label)}</span>
        </button>

        {langOpen && (
          <div className={classes.langDropdown}>
            {AI_AGENT_LANGUAGES.map((l) => (
              <button
                key={l.code}
                className={`${classes.langOption} ${lang === l.code ? classes.langActive : ""}`}
                onClick={() => { setLang(l.code); setLangOpen(false) }}
              >
                <span>{l.flag}</span>
                <span>{t(l.label)}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentLanguageSelector;